<template>
  <div :class="['c-sidenav', {'c-sidenav--open': isMenuOpen }]">
    <side-nav-burger />

    <div class="c-sidenav__nav-wrapper">
      <div class="c-sidenav__logo-wrapper">
        <router-link class="c-sidenav__logo" :to="{ name: 'contextSelection' }" @click.native="closeMenu">
          <img src="@/assets/images/logo/cashflows-logo-white.svg" alt="Cashflows Logo" class="c-sidenav__logo-img">
        </router-link>
      </div>
      <div class="c-sidenav__nav-area">
        <div class="c-sidenav__context-select">
          <side-nav-context-select />
        </div>
        <side-nav-menu class="c-sidenav__nav-list"/>
        <div class="c-sidenav__bottom-area">
          <side-nav-notifications />

          <side-nav-profile />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menu, shortcut } from '@/mixins/helpers'

import SideNavMenu from './Menu/SideNavMenu'
import SideNavBurger from './SideNavBurger'
import SideNavContextSelect from './SideNavContextSelect'

import SideNavNotifications from './Menu/SideNavNotifications'
import SideNavProfile from './Menu/SideNavProfile'

export default {
  name: 'SideNav',

  components: {
    SideNavMenu,
    SideNavBurger,
    SideNavContextSelect,
    SideNavNotifications,
    SideNavProfile
  },

  mixins: [ menu, shortcut ],

  computed: {
    shortcuts () {
      return [
        { combinations: 'esc', handler: this.closeMenu }
      ]
    }
  },

  created: function () {
    document.addEventListener('click', this.onDocumentClick)
  },

  destroyed: function () {
    document.removeEventListener('click', this.onDocumentClick)
  },

  methods: {
    onDocumentClick (event) {
      if (this.isMenuOpen && this.isInWhiteList(event.target) === false) {
        this.closeMenu()
      }
    },

    isInWhiteList (element) {
      const contextSelect = document.querySelector('.sidenav-context-select')

      return [this.$el, ...this.$el.querySelectorAll('*'), contextSelect, ...contextSelect.querySelectorAll('*')].includes(element)
    }
  }
}
</script>
